import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { PlaceholderFeed } from '@/imports/ui/components/placeholder/PlaceholderFeed';
import { Butterfly, ButterflyMain } from '@/layouts/Butterfly';

import { useResultsPage } from '../../hooks/useResultsPage';
import { ResultsContent } from './ResultsContent';

export const AIAskResultsPage: React.FC = () => {
  const router = useRouter();
  const queryToken = React.useMemo(() => {
    if (!router.isReady) return '';
    const raw = router.query.queryToken;
    return typeof raw === 'string' ? raw.trim() : '';
  }, [router.isReady, router.query.queryToken]);

  const { state, error, loading, indexData, isSearchReady } =
    useResultsPage(queryToken);

  return (
    <Butterfly>
      <ButterflyMain>
        {!isSearchReady ? (
          <PlaceholderFeed />
        ) : !queryToken ? (
          <Center minH={{ base: '40vh', md: '50vh' }} py="10">
            <Text color="gray.600" px="2">
              Missing query token.
            </Text>
          </Center>
        ) : loading ? (
          <Center minH={{ base: '40vh', md: '50vh' }} py="10">
            <Spinner size="lg" color="blue.500" thickness="3px" speed="0.65s" />
          </Center>
        ) : error ? (
          <Center minH={{ base: '40vh', md: '50vh' }} py="10">
            <Text color="red.500" px="2">
              {error}
            </Text>
          </Center>
        ) : state && indexData ? (
          <ResultsContent state={state} indexData={indexData} />
        ) : (
          <Box maxWidth="container.xl" mx="auto" p={{ base: 3, md: 6 }}>
            <Center minH={{ base: '40vh', md: '50vh' }} py="10">
              <Text color="gray.600" px="2">
                No records found
              </Text>
            </Center>
          </Box>
        )}
      </ButterflyMain>
    </Butterfly>
  );
};
